import { InjectionToken } from '@angular/core';
import { Media } from '@df/ui/display/media/interfaces';

export const MEDIA_OPTIONS = new InjectionToken<Media.IConfig>('MEDIA_OPTIONS');